// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-item > a:hover {
  color: var(--brand-accent, #d4af37) !important;
}

.nav-item ul .nav-item > a:hover {
  color: var(--brand-accent, #d4af37) !important;
}

.browse-sidebar-nav {
  display: block;
  width: 100%;
  padding: 4px 0 8px;
  margin: 0;
}

.browse-sidebar-list {
  list-style-type: none;
  padding-left: 0;
  margin: 0 0 2px;
}

.browse-sidebar-children {
  list-style-type: none;
  margin: 6px 0 10px 20px;
  padding-left: 18px;
  border-left: 1px solid rgba(0, 0, 0, 0.08);
}

.browse-sidebar-nav .nav-item {
  padding: 0;
}

.browse-sidebar-nav .nav-link {
  display: block;
  padding: 10px 16px 10px 28px;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  line-height: 1.35;
}

.browse-sidebar-children .nav-link {
  padding: 8px 12px 8px 14px;
}

.browse-sidebar-label {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  text-align: left;
  white-space: normal;
  max-width: 100%;
}

.browse-sidebar-label b {
  flex: 1 1 auto;
  min-width: 0;
  word-break: break-word;
}

.browse-sidebar-label app-category-visual {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  overflow: hidden;
}

a.nav-link[style*="d4af37"] .category-visual-svg,
.browse-sidebar-nav .nav-link .category-visual-svg.svg-active {
  filter: invert(58%) sepia(78%) saturate(450%) hue-rotate(5deg) brightness(95%) contrast(85%);
}

.icon {
  display: inline-block;
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
}

.icon svg {
  width: 28px !important;
  height: 28px !important;
}

.svg-gold {
  filter: invert(58%) sepia(78%) saturate(450%) hue-rotate(5deg) brightness(95%) contrast(85%) drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3));
}

@media(max-width: 959px){
  mat-toolbar{
    border-radius: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/sidebar/sidebar.component.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,4FAA4F;AAC9F;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wIAAwI;AAC1I;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".nav-item > a:hover {\n  color: var(--brand-accent, #d4af37) !important;\n}\n\n.nav-item ul .nav-item > a:hover {\n  color: var(--brand-accent, #d4af37) !important;\n}\n\n.browse-sidebar-nav {\n  display: block;\n  width: 100%;\n  padding: 4px 0 8px;\n  margin: 0;\n}\n\n.browse-sidebar-list {\n  list-style-type: none;\n  padding-left: 0;\n  margin: 0 0 2px;\n}\n\n.browse-sidebar-children {\n  list-style-type: none;\n  margin: 6px 0 10px 20px;\n  padding-left: 18px;\n  border-left: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.browse-sidebar-nav .nav-item {\n  padding: 0;\n}\n\n.browse-sidebar-nav .nav-link {\n  display: block;\n  padding: 10px 16px 10px 28px;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: unset;\n  line-height: 1.35;\n}\n\n.browse-sidebar-children .nav-link {\n  padding: 8px 12px 8px 14px;\n}\n\n.browse-sidebar-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 14px;\n  text-align: left;\n  white-space: normal;\n  max-width: 100%;\n}\n\n.browse-sidebar-label b {\n  flex: 1 1 auto;\n  min-width: 0;\n  word-break: break-word;\n}\n\n.browse-sidebar-label app-category-visual {\n  flex: 0 0 auto;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\na.nav-link[style*=\"d4af37\"] .category-visual-svg,\n.browse-sidebar-nav .nav-link .category-visual-svg.svg-active {\n  filter: invert(58%) sepia(78%) saturate(450%) hue-rotate(5deg) brightness(95%) contrast(85%);\n}\n\n.icon {\n  display: inline-block;\n  flex: 0 0 auto;\n  width: 28px;\n  height: 28px;\n}\n\n.icon svg {\n  width: 28px !important;\n  height: 28px !important;\n}\n\n.svg-gold {\n  filter: invert(58%) sepia(78%) saturate(450%) hue-rotate(5deg) brightness(95%) contrast(85%) drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.3));\n}\n\n@media(max-width: 959px){\n  mat-toolbar{\n    border-radius: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
